import styled from 'styled-components';

export const Container = styled.div`
  width: 180px;
  height: 50px;
  background: var(--background-item);

  border-radius: 50px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;

  p {
    font-size: 1.2rem;
    line-height: 21px;
  }
`;

interface CircleProps {
  circleColor: 'yellow' | 'green' | 'brown';
}

const colors = {
  yellow: '#E3AE02',
  green: '#0A78CB',
  brown: '#7D7979',
};

export const Circle = styled.div<CircleProps>`
  margin: 4.7px;
  width: 40px;
  height: 40px;
  background: ${props => colors[props.circleColor]};
  border-radius: 50px;
`;
